import { Injectable } from '@angular/core';
import {
  CompaniesClient,
  EditQualifiedPersonInviteCommand,
  QualifiedPersonInviteClient,
  QualifiedPersonInviteSearchViewModelQPInviteTotalTypePagedResultResponse,
  QualifiedPersonsClient,
  QualifiedPersonSearchViewModelTotalTypePagedResultResponse
} from '@services/cleanfill-api/cleanfill-api.generated';
import { ISearchQuery } from '@view-models/interfaces/search-query';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HttpQpService {
  constructor(
    private qpClient: QualifiedPersonsClient,
    private qpClientInvite: QualifiedPersonInviteClient,
    private companiesClient: CompaniesClient
  ) {}

  loadQps(query: ISearchQuery): Observable<QualifiedPersonSearchViewModelTotalTypePagedResultResponse> {
    return this.qpClient.searchQualifiedPerson(
      query.Page,
      query.PageSize,
      query.SortBy,
      query.FilterBy,
      new Date().getTimezoneOffset().toString()
    );
  }
  loadQpInvitations(
    uniqueId: string,
    query: ISearchQuery
  ): Observable<QualifiedPersonInviteSearchViewModelQPInviteTotalTypePagedResultResponse> {
    return this.qpClient.getCompanyInvites(
      uniqueId,
      uniqueId,
      query.Page,
      query.PageSize,
      query.SortBy,
      query.FilterBy,
      new Date().getTimezoneOffset().toString()
    );
  }
  editQualifiedPersonInvite(payload: EditQualifiedPersonInviteCommand): Observable<void> {
    return this.qpClientInvite.editQualifiedPersonInvite(new Date().getTimezoneOffset().toString(), payload);
  }

  inviteQp(payload): Observable<void> {
    // return this.companiesClient.inviteQp();
    return of();
  }
}
